<div class="modal-header" appCustomAutofocus>
    <h3 *ngIf="dependent.KeyID != -1">Edit Dependent</h3>
    <h3 *ngIf="dependent.KeyID == -1">Add New Dependent</h3>
</div>
<div class="modal-body">
    <div class="row" *ngIf="alert" style="margin-top: 12px;">
        <div class="col-md-12">
            <div class="alert" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-danger': alert.type == 'danger' }" role="alert">
                {{alert.msg}}
                <button type="button" class="close" (click)="closeAlert()">
                    <i class="modus-icons">close</i>
                </button>
            </div>
        </div>
    </div>
    <form #dependForm="ngForm">
        <div *ngIf="!isLoading && mode != 'attachmentOnly'">
            <div class="row" *ngFor="let group of groupedFields" style="margin-bottom: 10px;">
                <div *ngFor="let field of group" class="col-lg-6" [ngSwitch]="field.FieldDataType">
                    <label><strong>{{field.FieldLabel}}</strong></label>
                    <div *ngSwitchCase="1">
                        <div *ngIf="field.FieldVPColumnName == 'Relationship'">
                            <div *ngIf="relationshipList.length > 0">
                                <ng-select [ngClass]="{'is-invalid' : field.FieldIsRequiredForBenefits && !formData[field.FieldVPColumnName]}"
                                           [(ngModel)]="formData[field.FieldVPColumnName]"
                                           [required]="field.FieldIsRequiredForBenefits"
                                           name={{field.FieldVPColumnName}}
                                           [searchable]="false"
                                           [clearable]=false>
                                    <ng-option *ngFor="let data of relationshipList" [value]="data.value">{{data.name}}</ng-option>
                                </ng-select>
                            </div>
                            <div *ngIf="relationshipList.length < 1">
                                <input type="text" name={{field.FieldVPColumnName}} class="form-control formControlWidth" [ngStyle]="{'max-width': field.ApproximateWidth + 'px'}"
                                       [(ngModel)]="formData[field.FieldVPColumnName]" [ngClass]="{'is-invalid': field.FieldIsRequiredForBenefits && !formData[field.FieldVPColumnName]}"
                                       [required]="field.FieldIsRequiredForBenefits" />
                            </div>
                        </div>
                        <div *ngIf="field.FieldVPColumnName != 'Relationship'">
                            <input type="text" name={{field.FieldVPColumnName}} class="form-control formControlWidth" [ngStyle]="{'max-width': field.ApproximateWidth + 'px'}"
                                   [(ngModel)]="formData[field.FieldVPColumnName]" [ngClass]="{'is-invalid': field.FieldIsRequiredForBenefits && !formData[field.FieldVPColumnName]}"
                                   [required]="field.FieldIsRequiredForBenefits" maxlength="{{field.FieldLength}}"
                                   *ngIf="field.FieldVPColumnName != 'SSN' && field.FieldVPColumnName != 'Phone'" />
                            <input type="text" name={{field.FieldVPColumnName}} class="form-control formControlWidth ssnUS" [ngStyle]="{'max-width': field.ApproximateWidth + 'px'}"
                                   [(ngModel)]="formData[field.FieldVPColumnName]" [ngClass]="{'is-invalid': field.FieldIsRequiredForBenefits && !formData[field.FieldVPColumnName] && field.FieldIsRequiredForBenefits && (!newBornSSN || (newBornSSN && !ssnNotRequireOverride))}"
                                   (blur)="checkSSN(field)"
                                   appSsnFormat (valueChange)="updateSSN($event, field.FieldVPColumnName)"
                                   [required]="field.FieldIsRequiredForBenefits && (!newBornSSN || (newBornSSN && !ssnNotRequireOverride))"
                                   *ngIf="field.FieldVPColumnName == 'SSN'" placeholder="{{mode == 'approval'? ssnMask : ''}}" />
                            <input type="text" name={{field.FieldVPColumnName}} class="form-control formControlWidth" [ngStyle]="{'max-width': field.ApproximateWidth + 'px'}"
                                   [(ngModel)]="formData[field.FieldVPColumnName]" [ngClass]="{'is-invalid': field.FieldIsRequiredForBenefits && !formData[field.FieldVPColumnName]}"
                                   placeholder="{{phoneMask}}"
                                   appPhoneFormat (valueChange)="updatePhone($event, field.FieldVPColumnName)"
                                   [required]="field.FieldIsRequiredForBenefits"
                                   *ngIf="field.FieldVPColumnName == 'Phone'" />
                        </div>
                    </div>
                    <input type="checkbox"
                           name={{field.FieldVPColumnName}} trueFalseValue trueValue="Y" falseValue="N"
                           [(ngModel)]="formData[field.FieldVPColumnName]"
                           *ngSwitchCase="2" />
                    <input type="number" name={{field.FieldVPColumnName}} class="form-control formControlWidth" [ngStyle]="{'max-width': field.ApproximateWidth + 'px'}"
                           [(ngModel)]="formData[field.FieldVPColumnName]"
                           [required]="field.FieldIsRequiredForBenefits"
                           *ngSwitchCase="3" />
                    <div class="input-group" *ngSwitchCase="4">
                        <input type="text" class="form-control"
                               [(ngModel)]="formData[field.FieldVPColumnName]"
                               (ngModelChange)="check30Days(formData[field.FieldVPColumnName])"
                               bsDatepicker
                               #fromdp="bsDatepicker"
                               [outsideClick]="true"
                               [bsConfig]="datePickerOptions"
                               [readonly]="mobileMode"
                               [required]="field.FieldIsRequiredForBenefits"
                               name={{field.FieldVPColumnName}}
                               style="background-color:#ffffff">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-secondary input-group-text"
                                    (click)="fromdp.show()"
                                    style="margin-right:0px"
                                    [attr.aria-expanded]="fromdp.isOpen">
                                <i class="modus-icons">calendar</i>
                            </button>
                        </div>
                    </div>
                    <ng-select [ngClass]="{'is-invalid' : field.FieldIsRequiredForBenefits && !formData[field.FieldVPColumnName]}"
                               [(ngModel)]="formData[field.FieldVPColumnName]"
                               [required]="field.FieldIsRequiredForBenefits"
                               name={{field.FieldVPColumnName}}
                               [searchable]="false"
                               [clearable]=false
                               *ngSwitchCase="5">
                        <ng-option *ngFor="let option of field.fieldOptions[field.FieldVPColumnName]" [value]="option.DatabaseValue">{{option.DisplayValue}}</ng-option>
                    </ng-select>
                </div>
            </div>
        </div>
    </form>
    <div id="attachments">
        <div *ngIf="savedFiles.length > 0">
            <label><strong>Saved Files:</strong></label>
            <div *ngFor="let file of savedFiles" style="margin-bottom: 12px;">
                <a href="/Employee/GetFileAttachmentData?fileAttachmentID={{file.FileAttachmentID}}">
                    {{file.Filename}}{{file.AttachmentFileName}}
                </a>
            </div>
        </div>
        <label style="margin-top: 12px;"><strong><span *ngIf="!dependent.DependentIsDocumented && docsRequired && keyID == -1" [style.color]="'red'">*</span>New Attachments:</strong></label>
        <br />
        <div class="row">
            <div class="col-lg-5 col-md-5">
                <div ngfDrop
                     multiple="1"
                     selectable="1"
                     [(validDrag)]="validComboDrag"
                     [(files)]="formData.fileDrop"
                     accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
                     [(dragFiles)]="dragFiles"
                     class="drop-box"
                     [class.invalid-drag]="validComboDrag===false"
                     [class.valid-drag]="validComboDrag"
                     (filesChange)="upload()"
                     [ngfFixOrientation]="false">
                    Drop a file or Click to upload
                </div>
            </div>
            <div class="col-lg-7 col-md-7">
                <div *ngFor="let file of newFiles" style="margin-bottom: 5px">
                    {{file.Filename}}
                    <a [routerLink]="" (click)="deleteUnsavedAttachment(file)" *ngIf="file.File != null && file.Progress == null" style="color:red;">Remove</a>
                    <div style="padding-left:15px;margin-top:5px;">
                        <div class="progress" style="width:300px;" *ngIf="file.Progress > 0 && file.Progress < 100">
                            <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': file.Progress + '%' }">{{file.Progress}}%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br />
    <div *ngIf="!dependent.DependentIsDocumented && docsRequired && keyID == -1" [style.color]="'red'">
        <p>*required</p>
    </div>
    <div *ngIf="btmText != null && btmText != ''">
        <div class="card border">
            <div class="card-body">{{btmText}}</div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-danger mr-auto"
            (click)="deleteClicked()"
            *ngIf ="hRDPKeyID != -1 && mode != 'approval'">
        Remove Dependent
    </button>
    <button class="btn btn-default"
            *ngIf="mode != 'approval'"
            (click)="cancelClicked()">
        Cancel
    </button>
    <button class="btn btn-primary"
            *ngIf="mode == 'attachmentOnly'"
            (click)="saveAttachments()"
            [disabled]="newFiles?.length < 1 || savingDependent">
        Save Attachments
    </button>
    <button class="btn btn-primary"
            *ngIf="mode != 'attachmentOnly' && mode != 'approval'"
            (click)="saveClicked()"
            [disabled]="dependForm.form.invalid || (!dependForm.form.dirty && newFiles?.length < 1) || savingDependent || (hRDPKeyID == -1 && docsRequired && newFiles?.length < 1)">
        Save
    </button>
    <span *ngIf="savingDependent && mode != 'approval'">
        <img src="/Cache/images/icon_load.gif" alt="Loading..." />
    </span>
    <div class="row col-lg-12" style="margin-bottom:15px;" *ngIf="mode == 'approval'">
        <label style="float: left;"><strong>Notes</strong></label>
        <input type="text" class="form-control" [(ngModel)]="formData.notes" />
    </div>
    <div class="row" *ngIf="!dependent.DependentIsDocumented && docsRequired && dependent.HRDPKeyID == -1 && mode == 'approval'" style="margin-top: 12px; margin-bottom: 15px;">
        <div class="col-lg-12">
            <div class="alert-danger" role="alert">
                Documentation of this dependent's relationship is required before the request can be processed - please attach supporting documentation to the request.
            </div>
        </div>
    </div>
    <button type="button" class="btn btn-outline-dark mt-1"
            *ngIf="mode == 'approval'"
            (click)="cancelClicked()"
            [disabled]="gettingFilesData">
        Cancel
    </button>
    <button type="button" class="btn btn-danger mt-1"
            *ngIf="mode == 'approval'"
            (click)="rejectClicked()"
            [disabled]="gettingFilesData || formData.notes.length < 1">
        Reject
    </button>
    <button type="button" class="btn btn-success mt-1"
            *ngIf="mode == 'approval'"
            (click)="approveClicked()"
            [disabled]="!dependent.DependentIsDocumented && newFiles.length < 1 && docsRequired && dependent.HRDPKeyID == -1 || gettingFilesData">
        Approve
    </button>
</div>
